import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import PageNameV2 from "components/v2/common/PageNameV2";
import PageTitleV2 from "components/v2/common/PageTitleV2";
import ShopSelectBoxV2 from "components/v2/common/ShopSelectBoxV2";
import {closePopup, getParameter, openPopup} from "utils/CommonUtils";
import {deliTypeFormat} from "utils/formatUtils";
import {createYearList} from "utils/orderUtils";
import {subNavEvent} from "static/js/service/commonService";
import "assets/css/statistics.css";
import chartArrow from "assets/images/chartArrow.svg";
import chartArrow2 from "assets/images/chartArrow2.svg";
import MultiAxisLineChart from "../../statistics/MultiAxisLineChart";
import {ReactComponent as PopupXBtn} from "assets/images/icon/popupXBtn.svg";
import {useGetDailyStatisticsApi, useGetMonthlyStatisticsApi} from "../../../hooks/StatisticsHook";

export default function Statistics2V2() {
  const [shopId, setShopId] = useState();
  const [monthDataList, setMonthDataList] = useState([]);
  const [dayDataList, setDayDataList] = useState([]);
  const [date, setDate] = useState(null);
  const [calendar, setCalendar] = useState([]);
  const getYear = Number(getParameter("year")) || new Date().getFullYear();
  const getMonth = Number(getParameter("month")) || new Date().getMonth() + 1;
  const defaultYear = 2024;
  const deliType = Number(getParameter("deliType")) || 0;

  const yearList = createYearList(new Date().getFullYear(), defaultYear);
  const monthList = [1,2,3,4,5,6,7,8,9,10,11,12];

  const searchData1 = {
    shopId: shopId,
    year: getYear,
    month: getMonth,
  }

  const searchData2 = {
    shopId: shopId,
    date: date
  }

  if (deliType !== 0) {
    searchData1.deliveryType = deliType
    searchData2.deliveryType = deliType
  }

  useGetMonthlyStatisticsApi({setMonthDataList}, searchData1);
  useGetDailyStatisticsApi({setDayDataList}, searchData2);

  if (dayDataList.length > 0) {
    let getDateTotalCount = 0;
    let getDateTotalCost = 0;

    dayDataList.forEach((value) => {
      getDateTotalCount += value.orderDoneCount || 0; // 값이 없을 경우 기본값 0을 추가
      getDateTotalCost += value.totalPaymentCost || 0; // 값이 없을 경우 기본값 0을 추가
    });

    document.getElementById("dateCount").innerText = `${getDateTotalCount.toLocaleString()}건`;
    document.getElementById("dateCost").innerText = `${getDateTotalCost.toLocaleString()}원`;
  } else {
    try {
      document.getElementById("dateCount").innerText = `0건`;
      document.getElementById("dateCost").innerText = `0원`;
    } catch (e) {

    }
  }

  const changeYear = (value) => {
    const yearSelectText = document.querySelector(".yearSelectText");
    yearSelectText.setAttribute("data-id", value);
    yearSelectText.innerText = `${value}년`;
  };
  const changeMonth = (value) => {
    const yearSelectText = document.querySelector(".monthSelectText");
    yearSelectText.setAttribute("data-id", value);
    yearSelectText.innerText = `${value}월`;
  };
  const changeDeliType = (id, name) => {
    const yearSelectText = document.querySelector(".deliTypeSelectText");
    yearSelectText.setAttribute("data-id", id);
    yearSelectText.innerText = name;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const select = document.querySelectorAll(".selectEvent");
      select.forEach((element) => {
        element.classList.remove("active");
      });

      if (e.target.classList.contains("selectText")) {
        const dataHref = e.target.getAttribute("data-href");
        const selectBox = document.getElementById(`${dataHref}`);
        selectBox.classList.add("active");
      }
    };

    document.addEventListener("click", handleClickOutside);
    subNavEvent("calculateNav", "calculate3");


  }, []);

  useEffect(() => {
    setCalendar(generateCalendar(getYear, getMonth - 1, monthDataList));
  }, [getYear, getMonth, monthDataList]);

  const createUrlLink = (id, year, month, type) => {
    return `/v2/statistics/month?shopId=${id}&year=${year}&month=${month}&deliType=${type}`;
  }

  const searchEvnet = () => {
    const today = new Date();
    const getShopId = document.querySelector("#shopSelectText").getAttribute("data-id");
    const getYear = document.querySelector("#yearSelectText").getAttribute("data-id");
    const getMonth = document.querySelector("#monthSelectText").getAttribute("data-id");
    const getDeliType = document.querySelector("#deliTypeSelectText").getAttribute("data-id");

    if (today.getFullYear() === Number(getYear) && today.getMonth() + 1 < Number(getMonth)) {
      window.location.href = createUrlLink(getShopId, getYear, today.getMonth() + 1, getDeliType);
    } else {
      window.location.href = createUrlLink(getShopId, getYear, getMonth, getDeliType);
    }
  };

  const yearBtnEvent = (year) => {
    if (year > new Date().getFullYear()) return false;
    const getMonth = document.querySelector("#monthSelectText").getAttribute("data-id");

    window.location.href = createUrlLink(shopId, year, getMonth, deliType);
  }

  const monthBtnEvent = (year, month) => {
    if (year >= new Date().getFullYear() && month > new Date().getMonth() + 1) return false;

    if (month === 0) {
      window.location.href = createUrlLink(shopId, year - 1, 12, deliType);
    } else if (month === 13) {
      window.location.href = createUrlLink(shopId, year + 1, 1, deliType);
    } else {
      window.location.href = createUrlLink(shopId, year, month, deliType);
    }
  }

  function generateCalendar(year, month, list) {
    // 주의: month는 0 (1월)부터 시작하므로, 입력은 실제 월보다 1 작은 값을 넣어야 함
    const firstDay = new Date(year, month, 1); // 해당 달의 첫 날
    const lastDay = new Date(year, month + 1, 0); // 해당 달의 마지막 날
    const calendar = [];

    let currentDay = new Date(firstDay); // 현재 날짜를 추적하기 위한 변수
    let week = new Array(7).fill(null); // 빈 주 배열 (일~토)

    // 달력은 해당 달의 첫 번째 일요일부터 시작
    currentDay.setDate(currentDay.getDate() - currentDay.getDay()); // 첫 번째 일요일로 이동

    while (currentDay <= lastDay || currentDay.getDay() !== 0) {
      // 해당 주의 날짜를 배열에 넣음
      if (currentDay.getMonth() === month) {
        const dayOfMonth = currentDay.getDate();
        const matchedData = list && Array.isArray(list)
          ? list.find(item => item.dayOfMonth === dayOfMonth)
          : null;

        // 날짜와 일치하는 데이터가 있을 경우 추가, 없으면 날짜만 표시
        week[currentDay.getDay()] = matchedData
          ? { day: dayOfMonth, orderCancelCount: matchedData.orderCancelCount, orderDoneCount: matchedData.orderDoneCount, totalPaymentCost: matchedData.totalPaymentCost }
          : { day: dayOfMonth, orderCancelCount: 0, orderDoneCount: 0, totalPaymentCost: 0 };
      } else {
        week[currentDay.getDay()] = null; // 다른 달의 날짜는 null로 설정
      }

      // 일주일이 채워지면 달력에 추가하고 새로운 주 배열 생성
      if (currentDay.getDay() === 6) {
        calendar.push(week);
        week = new Array(7).fill(null); // 새 주 초기화
      }

      // 다음 날로 이동
      currentDay.setDate(currentDay.getDate() + 1);
    }

    return calendar;
  }

  const calculateSums = (calendar) => {
    const weekSums = [];
    const daySums = Array.from({ length: 7 }, () => ({ count: 0, cost: 0 }));
    let monthSum = { count: 0, cost: 0 };

    // 최대, 최소 매출액 초기화
    let maxDay = { cost: -Infinity };
    let minDay = { cost: Infinity };

    calendar.forEach((week) => {
      let weeklyCount = 0;
      let weeklyCost = 0;

      week.forEach((value, dayIndex) => {
        if (value) {
          weeklyCount += value.orderDoneCount || 0;
          weeklyCost += value.totalPaymentCost || 0;

          // 요일 합계
          daySums[dayIndex].count += value.orderDoneCount || 0;
          daySums[dayIndex].cost += value.totalPaymentCost || 0;

          // 최대/최소 매출액 비교
          if (value.totalPaymentCost > maxDay.cost) {
            maxDay = { day: value.day, cost: value.totalPaymentCost };
          }
          if (value.totalPaymentCost < minDay.cost) {
            minDay = { day: value.day, cost: value.totalPaymentCost };
          }
        }
      });

      weekSums.push({ count: weeklyCount, cost: weeklyCost });
      monthSum.count += weeklyCount;
      monthSum.cost += weeklyCost;
    });

    return { weekSums, daySums, monthSum, maxDay, minDay };
  };

  const { weekSums, daySums, monthSum, maxDay, minDay } = calculateSums(calendar);

  return (
    <>
      <article id="statisticsPopup" className="statisticsPopup d-flex a-center j-center hide">
        <div className="popupBody">
          <div className="box">
            <div className="head d-flex a-center j-between">
              <div className="d-flex a-center j-left">
                <p className="fs-20 mr-20 fc-white">{date}</p>
                <p id="dateCount" className="fs-24 fw-5 mr-10 fc-white"></p>
                <p id="dateCost" className="fs-24 fw-7 fc-white"></p>
              </div>
              <button className="closeBtn" onClick={() => {
                document.getElementById("statisticsPopup").classList.add("hide");
              }}>
                <PopupXBtn  />
              </button>
            </div>
            <div className="body bg-white">
              <div className="axis d-flex a-center j-right mb-10">
                <span className="green"></span>
                <p className="fs-14 ml-5">총 매출액</p>
                <span className="blue ml-20"></span>
                <p className="fs-14 ml-5">총 주문건수</p>
              </div>
              <div className="chartBox">
                <MultiAxisLineChart list={dayDataList} />
              </div>
            </div>
          </div>
        </div>
      </article>

      <main id="statistics" className="mainV2">
        <div className="container">
          <section className="containerInner">
            <PageNameV2 title1='정산 관리' title2='통계' />
            <div className="pageTitle mb-10 d-flex a-center j-between">
              <PageTitleV2 title="통계" countText="" count="" unit="" />
            </div>

            <article className="searchBox d-flex a-end j-left bg-white pt-15 pr-15 pb-10 pl-15 mb-30">
              <div>
                <p className="fw-7 mb-5">상호명</p>
                <div id="shopSelectBox">
                  <ShopSelectBoxV2 url="/v2/statistics/month" setShopId={setShopId} />
                </div>
              </div>
              <div className="ml-15">
                <p className="fw-7 mb-5">날짜</p>
                <div className="d-flex a-center j-left">
                  <div className='selectBox'>
                    <div id="yearSelect" className='select selectEvent width160'>
                      <div id="yearSelectText" className='yearSelectText selectText' data-id={getYear} data-href="yearSelect">
                        {getYear}년
                      </div>
                      <ul className='year selectOptionList'>
                        {yearList.map((value) => {
                          return (
                            <li className='selectoption' key={value} onClick={() => changeYear(value)}>{value}년</li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className='selectBox'>
                    <div id="monthSelect" className='select selectEvent width160'>
                      <div id="monthSelectText" className='monthSelectText selectText' data-id={getMonth} data-href="monthSelect">
                        {getMonth}월
                      </div>
                      <ul className='month selectOptionList'>
                        {monthList.map((value) => {
                          return (
                            <li className='selectoption' key={value} onClick={() => changeMonth(value)}>{value}월</li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ml-15">
                <p className="fw-7 mb-5">주문유형</p>
                <div className='selectBox'>
                  <div id="deliTypeSelect" className='select selectEvent width160'>
                    <div id="deliTypeSelectText" className='deliTypeSelectText selectText' data-id={deliType} data-href="deliTypeSelect">
                      {deliTypeFormat(deliType)}
                    </div>
                    <ul className='deliType selectOptionList'>
                      <li className="selectoption" onClick={() => changeDeliType(0, "전체")}>전체</li>
                      <li className="selectoption" onClick={() => changeDeliType(1, "배달")}>배달</li>
                      <li className="selectoption" onClick={() => changeDeliType(2, "방문포장")}>방문포장</li>
                    </ul>
                  </div>
                </div>
              </div>
              <button className="searchBtn bg-blue fc-white fw-7 ml-15" onClick={() => searchEvnet()}>조회</button>
            </article>

            <article className="tapBtnBox mb-10 bg-white">
              <Link to="/v2/statistics" className="d-inline ta-center">월별 매출</Link>
              <Link to="/v2/statistics/month" className="d-inline ta-center bg-blue fc-white fw-7">일별&시간대별 매출</Link>
            </article>

            <article className="lineChartBox monthBox bg-white">
              <div className="d-flex a-center j-between">
                <div className="width230"></div>
                <div className="btnBox d-flex a-center j-center mb-20">
                  <button className="prev mr-20" onClick={() => yearBtnEvent(getYear - 1)}>
                    <img src={chartArrow2} alt="이전 년" />
                  </button>
                  <button className="prev" onClick={() => monthBtnEvent(getYear, getMonth - 1)}>
                    <img src={chartArrow} alt="이전 달" />
                  </button>
                  <p className="fs-24 fw-7 ml-25 mr-25">{getYear}년 {getMonth}월</p>
                  <button className="next" onClick={() => monthBtnEvent(getYear, getMonth + 1)}>
                    <img src={chartArrow} alt="다음 달"/>
                  </button>
                  <button className="next ml-20" onClick={() => yearBtnEvent(getYear + 1)}>
                    <img src={chartArrow2} alt="다음 년"/>
                  </button>
                </div>
                <p className="fc-red fs-14 width230">*날짜 클릭 시 시간대별 매출 확인 가능</p>
              </div>

              <div className="calendarBox">
                <div className="calendarTr d-flex a-center j-left">
                  <div className="fw-5 ta-center">일</div>
                  <div className="fw-5 ta-center">월</div>
                  <div className="fw-5 ta-center">화</div>
                  <div className="fw-5 ta-center">수</div>
                  <div className="fw-5 ta-center">목</div>
                  <div className="fw-5 ta-center">금</div>
                  <div className="fw-5 ta-center">토</div>
                  <div className="fw-7 ta-center">합계</div>
                </div>
                {calendar.map((week, weekIndex) => {
                  return (
                    <div
                      className="calendarTr containerData d-flex a-center j-left"
                      key={`week-${weekIndex}`}
                    >
                      {week.map((value, dayIndex) => {
                        if (!value) return <div key={`day-${weekIndex}-${dayIndex}`} />; // 빈 값 처리

                        const today = new Date(); // 오늘 날짜
                        const selectedDate = new Date(`${getYear}-${getMonth}-${value.day}`); // 주어진 년/월/일로 날짜 생성

                        // 오늘 날짜와 비교
                        const todayCheck =
                          today.getFullYear() === selectedDate.getFullYear() &&
                          today.getMonth() + 1 === getMonth && // month는 0부터 시작하므로 +1 필요
                          today.getDate() === value.day;

                        return (
                          <div
                            className={`${dayIndex === 0 ? "first" : ""}`}
                            key={`day-${weekIndex}-${dayIndex}`}
                            onClick={() => {
                              if (value) {
                                const formattedMonth = String(getMonth).padStart(2, "0");
                                const formattedDay = String(value.day).padStart(2, "0");

                                setDate(`${getYear}-${formattedMonth}-${formattedDay}`);
                                openPopup("statisticsPopup");
                              }
                            }}
                          >

                          <p className={`day ${todayCheck ? "today" : ""}`}>
                              <span className={`d-inline ${todayCheck ? "todaySpan ta-center fc-white" : ""}`}>
                                {value.day}
                              </span>
                              {value.totalPaymentCost === minDay.cost && value.totalPaymentCost !== 0 &&
                                <span className="minDay ml-5 fs-14">최저 매출일</span>
                              }
                              {value.totalPaymentCost === maxDay.cost && value.totalPaymentCost !== 0 &&
                                <span className="maxDay ml-5 fs-14">최고 매출일</span>
                              }
                            </p>
                            <p className="fw-7 fs-18">{value.orderDoneCount.toLocaleString() || 0}건</p>
                            <p className="fw-7 fs-18">{value.totalPaymentCost?.toLocaleString() || 0}원</p>
                          </div>
                        );
                      })}
                      <div>
                        <p className="fs-14 mb-5">{weekIndex + 1}주차 합계</p>
                        <p className="fs-18">{weekSums[weekIndex].count.toLocaleString()}건</p>
                        <p className="fw-7 fs-18 fBlue">{weekSums[weekIndex].cost.toLocaleString()}원</p>
                      </div>
                    </div>
                  );
                })}
                <div className="calendarTr containerData d-flex a-center j-left">
                  {daySums.map((daySum, dayIndex) => (
                    <div key={`day-sum-${dayIndex}`}>
                      <p className="fs-14 mb-5">{["일", "월", "화", "수", "목", "금", "토"][dayIndex]}요일 합계</p>
                      <p className="fs-18">{daySum.count.toLocaleString()}건</p>
                      <p className="fw-7 fs-18 fSky">{daySum.cost.toLocaleString()}원</p>
                    </div>
                  ))}
                  <div>
                    <p className="fs-14 redBox fc-white ta-center">월 합계</p>
                    <p className="fs-18">{monthSum.count.toLocaleString()}건</p>
                    <p className="fw-7 fs-18 fc-red">{monthSum.cost.toLocaleString()}원</p>
                  </div>
                </div>
              </div>
            </article>
          </section>
        </div>
      </main>
    </>
  )
}